export function roundFractional(num, threshold = 0.0001, maxDecimalPlaces = 10) {
    const currentNum = parseFloat(num);

    if (isNaN(currentNum)) {
        return("Invalid");
    }

    let factor = 1;
    let roundedNum = currentNum;

    for (let i = 0; i < maxDecimalPlaces; i++) {
        factor *= 10;

        // Округляем число до текущей точности
        const candidate = Math.floor(currentNum * factor) / factor;

        // Рассчитываем потерю точности
        const loss = (currentNum - candidate) / currentNum;

        // Если потеря точности меньше порога, выходим из цикла
        if (loss <= threshold) {
            roundedNum = candidate;
            break;
        }
    }

    // Возвращаем число в нормальной форме (без научной нотации)
    return parseFloat(roundedNum.toFixed(maxDecimalPlaces));
}
